// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3cJDb","buttons":"SendReceipts_buttons__3xT56","email":"SendReceipts_email__1YcZf","bookApptTitle":"SendReceipts_bookApptTitle__HzvNl"};